;(function (angular) {
   'use strict'

   angular.module('azure.util', [])
})(angular)
